export default "__VITE_PUBLIC_ASSET__6c6e6db2__"